var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDentistClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 900",
    id: "dentist-clinic",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "dentist checkup"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#eff5f9",
    d: "M295.8,726c-24.45-18.8-132.33-106.36-143.46-233C136.71,315.17,324.13,204.15,375.55,173.69,493.42,103.87,776.78-1.44,956.42,155.87,1100.3,281.86,1089,513.62,1000,646.2,853.44,864.67,489.82,875.17,295.8,726Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 925.4,
    y: 455.88,
    fill: "none",
    stroke: "#c9effb",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 925.4,
    y: 513.64,
    fill: "none",
    stroke: "#c9effb",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 957.84,
    y: 484.81,
    fill: "#c9effb",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 892.95,
    y: 484.81,
    fill: "#c9effb",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 213.62,
    y: 598.88,
    fill: "none",
    stroke: "#c9effb",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 246.06,
    y: 656.63,
    fill: "none",
    stroke: "#c9effb",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 259.54,
    y: 627.81,
    fill: "#c9effb",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 194.66,
    y: 627.81,
    fill: "#c9effb",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 591.01,
    y: 213.44,
    fill: "#c9effb",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 612.93,
    y: 271.3,
    fill: "#c9effb",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 636.94,
    y: 242.37,
    fill: "none",
    stroke: "#c9effb",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.89,
    height: 28.93,
    x: 572.05,
    y: 242.37,
    fill: "none",
    stroke: "#c9effb",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    rx: 2
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Light/Equipment"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.8,
    height: 19.28,
    x: 670.33,
    y: 519.38,
    fill: "#e3eaf3",
    transform: "rotate(-180 683.725 529.02)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.95,
    height: 14.66,
    x: 612.93,
    y: 526.12,
    fill: "#e3eaf3",
    transform: "rotate(-180 625.41 533.45)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.73,
    height: 22.82,
    x: 530.31,
    y: 550.24,
    fill: "#e3eaf3",
    transform: "rotate(-180 562.68 561.645)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64.73,
    height: 22.82,
    x: 459.73,
    y: 406.67,
    fill: "#e3eaf3",
    transform: "rotate(-180 492.1 418.08)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54a4cc",
    d: "M529.89,826.06,531,182.26a6.29,6.29,0,0,1,6.29-6.28h57.39a11.75,11.75,0,0,1,5.09,1.16l87.43,42.17L704,207.12,603.46,158.4a9.27,9.27,0,0,0-4-.92h-77.7a9.25,9.25,0,0,0-9.25,9.24L511.39,826Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396e8e",
    d: "M520.37,178.82c0-5.11,1.16-13.36,8.73-13.36h70.48c1.39,0,10.51,4.44,11.76,5l85.79,41.58-10,7.23-87.43-42.17a11.75,11.75,0,0,0-5.09-1.16H537.26a6.29,6.29,0,0,0-6.29,6.28l-1.08,643.8-10.6,0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 775.55,
    cy: 268.2,
    fill: "#e3eaf3",
    rx: 136.95,
    ry: 72.52,
    transform: "rotate(-23.18 775.639 268.215)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80cbe8",
    d: "M816.5,183.23a187.21,187.21,0,0,0-45.38,4.4q-11.13,2.34-22,5.75c-7.22,2.26-14.35,4.79-21.33,7.66a276.58,276.58,0,0,0-40.27,20.4c-6.39,3.95-12.59,8.18-18.54,12.72a192.24,192.24,0,0,0-17,14.51,144.55,144.55,0,0,0-14.88,16.46c-1.18,1.43-2.18,3-3.28,4.43s-2,3.05-3,4.58a94.1,94.1,0,0,0-5.18,9.56,65.49,65.49,0,0,0-3.77,10A55.91,55.91,0,0,0,620,304.09a43.13,43.13,0,0,0,.67,10.29l.6,2.51c.18.84.53,1.62.78,2.45l.42,1.22.51,1.18c.32.8.74,1.56,1.12,2.33,3.2,6.14,8.38,11.22,14.38,15.23a71.69,71.69,0,0,0,20.12,8.94,121.38,121.38,0,0,0,22.21,4.14,191.81,191.81,0,0,0,22.9.79,130.63,130.63,0,0,1-46.28-.16,76.92,76.92,0,0,1-22.38-8.12,51.42,51.42,0,0,1-9.87-7.26,44.08,44.08,0,0,1-7.87-9.71c-.52-.92-1.07-1.82-1.51-2.78l-.7-1.42-.6-1.47c-.37-1-.83-1.95-1.12-3l-.89-3.05a50.61,50.61,0,0,1-1.3-12.55,60.22,60.22,0,0,1,1.77-12.3,74.91,74.91,0,0,1,4-11.57,103,103,0,0,1,12.27-20.67,153.14,153.14,0,0,1,15.83-17.69,204.68,204.68,0,0,1,37.61-28.13c6.75-3.93,13.67-7.56,20.75-10.82,1.78-.79,3.53-1.63,5.33-2.39l5.38-2.27c3.63-1.4,7.25-2.83,10.94-4.08a222.23,222.23,0,0,1,22.34-6.68,231.46,231.46,0,0,1,22.88-4.28C785.67,180.87,801.34,180.56,816.5,183.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80cbe8",
    d: "M676.82,332.59c-15.72-36.7,18.12-86.4,75.57-111s116.77-14.79,132.49,21.91c4,9.36,4.79,19.56,2.78,30,15.45-20.65,21.21-41.82,13.78-59.18-15.77-36.82-84.91-42.53-154.44-12.75S633.89,285.3,649.65,322.11c6.31,14.74,21.18,24.48,41.19,29A48.93,48.93,0,0,1,676.82,332.59Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 719.55,
    cy: 324.37,
    fill: "#80cbe8",
    rx: 27.07,
    ry: 15.24,
    transform: "rotate(-23.18 719.635 324.383)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 762.59,
    cy: 254.27,
    fill: "#80cbe8",
    rx: 27.07,
    ry: 15.24,
    transform: "rotate(-23.18 762.67 254.276)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 848.68,
    cy: 261.3,
    fill: "#80cbe8",
    rx: 27.07,
    ry: 15.24,
    transform: "rotate(-23.18 848.773 261.315)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 795.12,
    cy: 309.87,
    fill: "#80cbe8",
    rx: 27.07,
    ry: 15.24,
    transform: "rotate(-23.18 795.217 309.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 127.17,
    height: 93.98,
    x: 332.56,
    y: 395.86,
    fill: "#e3eaf3",
    rx: 5.78,
    transform: "rotate(-180 396.15 442.85)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.57,
    cy: 467.37,
    r: 4.68,
    fill: "#80cbe8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 343.9,
    cy: 467.37,
    r: 4.68,
    fill: "#80cbe8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 361.23,
    cy: 467.37,
    r: 4.68,
    fill: "#80cbe8"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.33,
    height: 29.33,
    x: 337.66,
    y: 403.42,
    fill: "#80cbe8",
    rx: 7.27,
    transform: "rotate(180 360.82 418.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.33,
    height: 29.33,
    x: 406.17,
    y: 452.71,
    fill: "#80cbe8",
    rx: 7.27,
    transform: "rotate(180 429.335 467.37)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 46.33,
    height: 29.33,
    x: 406.17,
    y: 403.42,
    fill: "#80cbe8",
    rx: 7.27,
    transform: "rotate(180 429.335 418.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.24,
    height: 93.98,
    x: 393.03,
    y: 395.86,
    fill: "#80cbe8",
    transform: "rotate(-180 396.15 442.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.24,
    height: 127.17,
    x: 393.03,
    y: 379.26,
    fill: "#80cbe8",
    transform: "rotate(90 396.15 442.85)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80cbe8",
    d: "M323.2,392.19V493.51a6.85,6.85,0,0,0,6.84,6.85H462.25a6.85,6.85,0,0,0,6.85-6.85V392.19a6.85,6.85,0,0,0-6.85-6.85H330A6.85,6.85,0,0,0,323.2,392.19Zm9.36,9.45a5.78,5.78,0,0,1,5.78-5.78H454a5.77,5.77,0,0,1,5.77,5.78v82.42a5.77,5.77,0,0,1-5.77,5.78H338.34a5.78,5.78,0,0,1-5.78-5.78Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 129.46,
    height: 51.1,
    x: 586.57,
    y: 536.1,
    fill: "#80cbe8",
    rx: 3.92,
    transform: "rotate(-180 651.3 561.645)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 333.13,
    height: 106.6,
    x: 151.41,
    y: 104.18,
    fill: "#e3eaf3",
    rx: 5.29
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#abbcca",
    d: "M484.47,150.6h-332a.85.85,0,0,1,0-1.7h332a.85.85,0,0,1,0,1.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 307.74,
    height: 19.04,
    x: 164.1,
    y: 179.63,
    fill: "#abbcca",
    rx: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3eaf3",
    d: "M469.47 186.21h-303a.85.85 0 110-1.7h303a.85.85 0 110 1.7zM469.47 193.64h-303a.85.85 0 010-1.7h303a.85.85 0 010 1.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30.46,
    height: 13.96,
    x: 427.75,
    y: 122.27,
    fill: "#abbcca",
    rx: 1.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 435.66,
    cy: 129.25,
    r: 3.93,
    fill: "#e3eaf3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 450.3,
    cy: 129.25,
    r: 3.93,
    fill: "#e3eaf3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 128.17,
    height: 113.76,
    x: 968.19,
    y: 143.85,
    fill: "#e3eaf3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a04833",
    d: "M962.45,141.19V258.74a5,5,0,0,0,5,5h127.78a5,5,0,0,0,5-5V141.19a5,5,0,0,0-5-5H967.45A5,5,0,0,0,962.45,141.19ZM1084,253.38H978.64a5,5,0,0,1-5-5V151.55a5,5,0,0,1,5-5H1084a5,5,0,0,1,5,5v96.83A5,5,0,0,1,1084,253.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80cbe8",
    fillRule: "evenodd",
    d: "M1030,171.87h4.4a60.77,60.77,0,0,1,11.9-2.63c5.28-.44,11,3.52,11.9,12.78s-4.4,20.28-6.17,28.67-2.64,18.51-6.62,19.83-7-4.4-8.82-11.47-2.63-9.27-4.84-9.27a2.62,2.62,0,0,1-.37,0,2.3,2.3,0,0,1-.36,0c-2.21,0-3.07,2.21-4.84,9.27s-4.84,12.78-8.82,11.47-4.85-11.47-6.62-19.83-7.05-19.4-6.17-28.67,6.61-13.22,11.9-12.78a62.42,62.42,0,0,1,11.9,2.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#454851",
    d: "M1030,171.67l4.4,0h-.07c2.19-.72,4.38-1.42,6.62-2,1.12-.27,2.25-.56,3.39-.77a16.4,16.4,0,0,1,3.56-.37,10.37,10.37,0,0,1,3.63.75,12.17,12.17,0,0,1,3.2,2,13.64,13.64,0,0,1,2.44,2.86,17.4,17.4,0,0,1,1.62,3.37,23,23,0,0,1,1.19,7.25,35.2,35.2,0,0,1-.8,7.15,113,113,0,0,1-4.05,13.3c-.74,2.16-1.43,4.28-2,6.45s-1,4.44-1.56,6.69-1,4.5-1.76,6.74a20.37,20.37,0,0,1-1.37,3.3,5.71,5.71,0,0,1-2.72,2.68,4.12,4.12,0,0,1-3.82-.51,8.85,8.85,0,0,1-2.51-2.67,19.56,19.56,0,0,1-1.64-3.14,32.52,32.52,0,0,1-1.25-3.28c-.69-2.24-1.27-4.44-2-6.57a15.42,15.42,0,0,0-1.27-3,2.37,2.37,0,0,0-.8-.87.83.83,0,0,0-.41-.13,2,2,0,0,0-.25,0l-.56,0h.32l-.57,0a1.5,1.5,0,0,0-.24,0,1,1,0,0,0-.35.17,2.68,2.68,0,0,0-.66.9,16.93,16.93,0,0,0-1,3c-.56,2.17-1,4.37-1.59,6.7a32,32,0,0,1-1.14,3.43,20.38,20.38,0,0,1-1.65,3.35,9.91,9.91,0,0,1-2.82,3.08l-.5.32-.58.26a5.48,5.48,0,0,1-1.25.35,7.37,7.37,0,0,1-1.33,0,7.13,7.13,0,0,1-1.27-.31,5.65,5.65,0,0,1-2.14-1.49,8,8,0,0,1-.7-.89l-.56-.9a21.62,21.62,0,0,1-1.42-3.54,70.26,70.26,0,0,1-1.67-6.89l-1.3-6.71c-.44-2.17-1-4.27-1.7-6.45-1.25-4.36-2.78-8.76-3.64-13.44a34.15,34.15,0,0,1-.68-7.18,22.28,22.28,0,0,1,1.29-7.22,14.68,14.68,0,0,1,4.06-6.17,11.88,11.88,0,0,1,3.16-2,10.73,10.73,0,0,1,3.59-.76,15.68,15.68,0,0,1,3.54.37c1.14.2,2.27.45,3.39.73,2.23.59,4.44,1.18,6.63,1.92l-.07,0Zm0,.4-1.63,0h-.07a58.05,58.05,0,0,0-6.64-1.66c-1.12-.21-2.24-.39-3.37-.52a14.73,14.73,0,0,0-3.31-.05,8.61,8.61,0,0,0-3,1,10.14,10.14,0,0,0-2.47,1.94,12.52,12.52,0,0,0-2.8,5.57,22.2,22.2,0,0,0-.47,6.35,40.28,40.28,0,0,0,1,6.45c1,4.3,2.52,8.58,3.93,13a68.58,68.58,0,0,1,1.8,6.84c.46,2.3.85,4.56,1.23,6.8a63.6,63.6,0,0,0,1.37,6.52,17.85,17.85,0,0,0,1,2.87,3.43,3.43,0,0,0,1.3,1.55,1.61,1.61,0,0,0,1.6-.2,6.81,6.81,0,0,0,1.82-1.93,25,25,0,0,0,2.66-5.79c.69-2.06,1.24-4.35,2-6.57a18.89,18.89,0,0,1,1.49-3.42,4.91,4.91,0,0,1,1.57-1.67,3.64,3.64,0,0,1,1.85-.5h.61l.3,0c.2,0,.39,0,.6.08a3.24,3.24,0,0,1,1.18.5,4.44,4.44,0,0,1,1.42,1.69,17,17,0,0,1,1.23,3.44c.62,2.25,1,4.54,1.62,6.69a22.81,22.81,0,0,0,2.57,6.16,7.7,7.7,0,0,0,2.11,2.34,2.89,2.89,0,0,0,2.73.33,4.27,4.27,0,0,0,2-2.13,18.66,18.66,0,0,0,1.1-3.1,58.35,58.35,0,0,0,1.26-6.68c.32-2.26.61-4.54,1-6.83a64.14,64.14,0,0,1,1.51-6.85c1.19-4.47,2.63-8.79,3.54-13.13s1.4-8.67.35-12.81a12.68,12.68,0,0,0-2.8-5.51,9.87,9.87,0,0,0-2.44-1.91,8.86,8.86,0,0,0-3-1,14.63,14.63,0,0,0-3.3,0c-1.12.12-2.25.25-3.37.47a58.62,58.62,0,0,0-6.65,1.63h-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80cbe8",
    fillRule: "evenodd",
    d: "M1068.27 159.1h0v.08s0 0 0 0l0 0h0l0 0h.05l0 0s0 0 .08 0l0 0h0l.06 0h0l.1 0h0l.11 0h.07l.08 0h.08l.06 0h0l0 0h.11l.07 0 0 0h.24l.13 0h.13l.12 0h.23l.11 0h.15l.08 0h.59a4.16 4.16 0 013.39 3.38v.58l0 .08v.38l0 .08 0 .13 0 .07 0 .06v.13l0 .13 0 .07v.24l0 .17 0 .09v.05l.06.2 0 .05v0l0 .07v0l0 0v0l0 .1v0l0 0h0v.1l0 0h.1l0 0v0h.1l0 0V166h0l0 0v0l0-.1v0l0 0v0l0-.07v0l0-.05.06-.2v-.05l0 0 0-.05 0-.17v-.24l0-.07 0-.13v-.13l0-.06 0-.07 0-.13V164l0-.08v-.15l0-.08v-.58a4.1 4.1 0 013.39-3.38h.59l.08 0h.15l.11 0h.23l.12 0h.12l.07 0 .07 0h.24l0 0 .06 0h.07l.1 0h0l.07 0h.08l.08 0h.07l.11 0h0l.1 0h0l.06 0h0l0 0 .08 0 0 0h0v0h0l.06-.07v-.08h0V159s0 0 0 0l0 0h0l0 0h0s0 0-.08 0l0 0h0l-.06 0h0l-.1 0h0l-.11 0h0l0 0h-.09l0 0h0l-.07 0h0l-.1 0h-.07l-.06 0H1081l-.07 0h-.06l-.07 0h-.13l-.06 0h-.15l-.08 0h-.12l-.11 0h-.82a4.17 4.17 0 01-3.39-3.38v-.59l0-.08v-.15l0-.08V154l0-.13 0-.06 0-.07v-.13l0-.13 0-.06v-.25l0-.16 0 0 0-.05v0l0-.15v-.05l0 0v0l0-.06v0l0 0v0l0-.1v0l0 0 0 0v-.05h0v0l0 0h-.23l0 0v0h0v.05l0 .07v0l0 .1v0l0 0v0l0 .06v0l0 0v.05l0 .15v0l0 .1 0 .16v.25l0 .06 0 .13v.13l0 .07 0 .06 0 .13 0 .08v.38l0 .08v.59a4.11 4.11 0 01-3.39 3.38h-.82l-.11 0h-.12l-.08 0H1070l-.06 0h-.07l-.13 0h-.06l-.07 0h-.16l-.07 0h-.06l0 0h-.07l-.06 0h0l0 0H1069l0 0h0l-.11 0h0l-.1 0h0l-.06 0h0l0 0-.08 0h0l0 0h0l-.06.07v.1zM1052.9 162.63v.08l0 0 .06.06h0l0 0h.19l.07 0h.16l0 0h.51l.06 0h.7a2.63 2.63 0 012.17 2.17v1l0 .08v.07l0 .06v.69l0 0v0h.12l.06-.06v-.54l0-.11v-.17l0-.08v-1a2.67 2.67 0 012.17-2.17h.7l.07 0h.5l0 0h.17l.06 0h.2l0 0h0l.08-.08v-.16l-.08-.09h-.18l-.06 0h-.13l-.05 0h-.07l0 0h-1.27a2.67 2.67 0 01-2.17-2.17v-1l0-.08V159l0-.12v-.53l-.06-.07h-.1l0 0h0l0 0V159l0 .07v.06l0 .08v1a2.66 2.66 0 01-2.17 2.17h-1.27l0 0h-.06l-.05 0h-.13l-.07 0H1053l-.06.07 0 0zM1063.13 176.65v.08s0 0 0 0l.07.06h0l0 0 .06 0 0 0h0l.07 0h0l.08 0h.12l0 0 0 0h.73l.08 0h.82a3.06 3.06 0 012.51 2.52v1.08l0 .09v.1l0 .08v.2l0 0v.1l0 0v0l0 0v0l0 .06v0l0 0v0l0 .05v0l0 0v.05l0 0v0l0 0h.1v0l0 0h0v0l0 0v0l0-.05 0 0 0 0v0l0-.06v0l0 0v-.06l0 0v-.07l0 0v-.2l0-.08v-1.27a3.08 3.08 0 012.52-2.52h.81l.09 0h.73l0 0 0 0h.12l.08 0h0l.06 0h0v0s0 0 .07 0v0h0l.07-.06a.06.06 0 000 0v-.16s0 0 0 0l-.07-.07h0s0 0-.07 0v0h0l-.06 0H1073l-.08 0h-.05l0 0h-.07l0 0h-.84l-.09 0h-.58a3.08 3.08 0 01-2.52-2.51v-1.28l0-.08v-.19l0 0v-.07l0-.06v0l0 0v0l0-.07v0l0 0 0 0 0-.05v0l0 0v0l0 0h0v0h-.1l0 0 0 0v.05h0v0l0 .05v0l0 0v0l0 .07v0l0 0v0l0 .06v.07l0 0v.19l0 .08v.1l0 .1v1.08a3.06 3.06 0 01-2.51 2.51h-.59l-.08 0h-.85l0 0h-.06l0 0h0l-.08 0h-.13l-.07 0h0l0 0s0 0-.06 0h0l-.07.07s0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3eaf3",
    fillRule: "evenodd",
    d: "M1040.66,181.75v.08s0,0,0,0l.06.06h0v0s0,0,.07,0l0,0h0l.06,0h0l.09,0h0l.08,0h0l0,0h.74l.08,0h.15l.08,0h.59a3.08,3.08,0,0,1,2.51,2.51v1.08l0,.09V186l0,.13v.13l0,0,0,0v.1l0,.07v0l0,0,0,0,.05,0v0h0l0,0v0l0,0,0,0v0h.1l0,0v0h0l0,0v0l0,0v0l0,0,0,0v-.06l0-.07v0l0,0v0l0,0v-.1l0,0v0l0-.13v-.22l0-.09v-1.08a3.08,3.08,0,0,1,2.51-2.51h.59l.08,0h.15l.08,0h.73l0,0h.05l.08,0h0l.08,0h0l.07,0h0l0,0s0,0,.06,0l0,0h0l.06-.06,0,0v-.17s0,0,0,0l-.06-.06h0l0,0s0,0-.06,0l0,0h0l-.07,0h0l-.08,0h-.11l0,0,0,0h-.73l-.08,0h-.15l-.08,0h-.59a3.08,3.08,0,0,1-2.51-2.51v-1.08l0-.09v-.22l0-.13v0l0,0v-.07l0-.06v0l0,0v0l0-.07v-.06l0,0,0-.05v0l0,0v0l0,0h0v0l0,0h-.1v0l0,.05v0l0,0h0v0l-.05.05,0,0,0,0v0l0,.07v.1l0,.06v.13l0,.13v.22l0,.09v1.08a3.08,3.08,0,0,1-2.51,2.51h-.59l-.08,0h-.15l-.08,0h-.74l0,0,0,0h-.11l-.09,0h0l-.06,0h0l0,0s0,0-.07,0v0h0l-.06.06,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#80cbe8",
    fillRule: "evenodd",
    d: "M995.72 238.52v-.1s0 0 0 0l0 0h0l0 0h0l0 0s0 0-.08 0l0 0h0l-.07 0h0l-.1 0h0l-.11 0h0l0 0-.08 0h-.08l-.06 0h-.07l-.05 0h-.06l-.07 0 0 0h-.24l-.13 0h-.07l-.06 0-.12 0h-.23l-.11 0h-.82a4.17 4.17 0 01-3.39-3.38v-.59l0-.08v-.38l0-.08 0-.13 0-.07v-.13l0-.06 0-.13v-.13l0-.12v-.06l0-.16 0-.1v-.05l-.06-.2 0-.05v0l0-.06v0l0 0v0l0-.1v0l0 0h0v0l0 0v0l-.05-.05h-.1v0l0 0h-.1l0 .05v.1h0l0 0v0l-.05.1v0l0 0v0l0 .06v0l0 .05-.06.2v.05l0 0 0 .05 0 .16v.24l0 .07 0 .13v.13l0 .06v.07l0 .13v.23l0 .08v.15l0 .08v.59a4.11 4.11 0 01-3.39 3.38h-.82l-.11 0h-.23l-.11 0-.07 0h-.13l-.07 0h-.24l-.05 0-.06 0h-.07l-.1 0h0l-.07 0h-.08l-.08 0-.05 0h0l-.11 0h0l-.1 0h0l-.06 0h0l0 0-.08 0 0 0h0l0 0h0l-.06.07v.1h0v.08s0 0 0 0l0 0h0l0 0h0l0 0s.05 0 .08 0l0 0h0l.06 0h0l.1 0h0l.11 0h0l.05 0 .08 0h.08l.07 0h0l.1 0h.07l.06 0 .05 0h.24l.07 0h.13l.07 0 .11 0h.23l.11 0h.82a4.17 4.17 0 013.39 3.38v.59l0 .08v.15l0 .08v.23l0 .13v.07l0 .06V244l0 .13 0 .07v.24l0 .16 0 .05 0 0v.05l0 .15v0l0 .05v0l0 .06v0l0 0v0l.05.1v0l0 0 0 0v.05h0v0l0 0h.1l0 0v0h.1l.05 0v0h0v-.05l0-.07v0l0-.1v0l0 0v0l0-.06v0l0-.05 0 0 0-.15v-.05l0-.1 0-.16v-.06l0-.12v-.13l0-.13 0-.06v-.13l0-.07 0-.13 0-.08v-.38l0-.08v-.59a4.11 4.11 0 013.39-3.38h.82l.11 0h.23l.12 0 .06 0h.07l.13 0h.24l0 0 .07 0h.06l.05 0h.07l.06 0h.08l.08 0 0 0h0l.11 0h0l.1 0h0l.07 0h0l0 0 .08 0 0 0h0l0 0h0l.06-.07v-.08zM1011.09 235v-.08h0l-.06-.07h0l0 0h-.19l-.07 0h-.16l0 0H1010l-.06 0h-.7a2.62 2.62 0 01-2.17-2.17v-1l0-.08v-.07l0-.06v-.69l0 0 0 0h-.12l-.06.06v.54l0 .12v.16l0 .08v1a2.67 2.67 0 01-2.17 2.17h-.7l-.07 0h-.5l0 0H1003l-.06 0h-.2l0 0h0l-.08.08v.17l.08.08h.18l.06 0h0l.06 0h.17l0 0h.5l.07 0h.7a2.65 2.65 0 012.17 2.17v1l0 .08v.16l0 .12v.54l.06.06h.1l0 0h0l0 0v-.69l0-.06v-.07l0-.08v-1a2.64 2.64 0 012.17-2.17h.7l.06 0h.51l0 0h.16l.07 0h0l.07 0h.18l.06-.07h0zM1000.86 221v-.08s0 0 0 0l-.06-.06h0l0 0-.06 0 0 0h0l-.07 0h0l-.08 0h-.12l0 0h-.11l-.05 0h-.62l-.08 0h-.82a3.08 3.08 0 01-2.51-2.52V217l0-.1v-.1l0-.08v-.2l0 0v-.1l0 0v0l0 0v0l0-.06v-.07l0 0 0-.05v0l0 0v0l0 0v0h-.13l0 0 0 0h0v0l0 0v0l-.05.05 0 0 0 0v0l0 .06v.1l0 0 0 0v.13l0 .13v0l0 .08v1.27a3.08 3.08 0 01-2.52 2.52H992l-.08 0h-.62l-.05 0h-.12l0 0H991l-.09 0h0l-.06 0h0v0s0 0-.07 0v0h0l-.07.06a.06.06 0 000 0V221s0 0 0 0l.07.07h0l.07 0h.05l.06 0H991l.08 0h0l.05 0h.07l.05 0h.84l.09 0h.58a3.08 3.08 0 012.52 2.51v1.28l0 .08v0l0 .13v.13l0 .07v.09l0 .07v0l0 0 0 0 .05 0v0l0 0V226l0 0h0v0h.1l0 0 .05-.05v0h0l0 0v0l0 0 0 0v-.06l0-.07v0l0 0v0l0-.07v-.06l0 0v-.19l0-.08V225l0-.1v-1.08a3.08 3.08 0 012.51-2.51h.59l.08 0h.85l.05 0h.06l0 0h.05l.08 0h.13l.07 0h0s.05 0 .06 0h0l.06-.07s0 0 0 0z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 225.03,
    height: 22.23,
    x: 170.91,
    y: 611.54,
    fill: "#cc7829",
    rx: 9.36
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cc7829",
    points: "187.29 826.06 168.02 826.06 192.07 633.77 211.19 633.77 187.29 826.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#cc7829",
    points: "379.62 826.06 398.83 826.06 374.78 633.77 355.67 633.77 379.62 826.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a04833",
    points: "192.07 633.77 211.19 633.77 189.52 653.57 192.07 633.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#a04833",
    points: "374.78 633.77 355.67 633.77 358.22 653.57 374.78 633.77"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Doctor/Botoom/Sitting"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M188.24,552.43s-21.36,43.3,18.47,64.07,64.65,28.29,65.8,37-6.35,20.2-2.88,54.83,9.23,75.61,9.23,75.61,30.59,4.62,35.21,0-1.15-62.59,4-114.7c0,0,9.81-25-3.17-40.56l-14-15.4s101.74,20,87.26,4.09C371.48,599,321.67,581.07,280,560.19l-2.16-7.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M188.24,552.43s-21.36,43.3,18.47,64.07,64.65,28.29,65.8,37-6.35,20.2-2.88,54.83,9.23,75.61,9.23,75.61,30.59,4.62,35.21,0-1.15-62.59,4-114.7c0,0,9.81-25-3.17-40.56l-11-10.39-26.1-65.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M350.2,816.78C341,808.51,319,798.12,314,783.88c-3.83,3.84-25.59,1.3-32.84.33h0s-3.52,11.21-3.71,19.29,0,10.39,0,10.39l13.47,1.73v-3.46s7.88.39,12.12,4.62,16.35,9.81,29.43,9.23S359.43,825.05,350.2,816.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc065",
    d: "M332.49,826c-13.09.58-25.21-5-29.44-9.23s-12.12-4.62-12.12-4.62v3.46l-13.47-1.73s-.19-2.31,0-10.39a67,67,0,0,1,1.92-12.66c.92-3.82,1.8-6.63,1.8-6.63,7.25,1,29,3.5,32.84-.33a26.29,26.29,0,0,0,4.52,7.74c.62.79,1.3,1.56,2,2.31s1.18,1.2,1.79,1.8c.79.75,1.59,1.5,2.44,2.24,8.53,7.43,19.54,13.55,25.43,18.81C359.42,825.05,345.57,825.44,332.49,826Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7c2f13",
    d: "M332.49 826c10.51-.46 21.5-.8 20.65-5.2-32.85 7.88-45.85-5-48.24-8.84s-8.19-4.23-8.19-4.23c-10.64-.12-16.33-3.5-19.14-6.1-.05.63-.09 1.26-.1 1.86-.2 8.08 0 10.39 0 10.39l13.47 1.73v-3.46s7.88.39 12.12 4.62S319.41 826.59 332.49 826zM320.53 793.93c-.63.42-1.29.82-1.94 1.19a18.32 18.32 0 01-2.78 1.34 12 12 0 01-3.27.89 8.52 8.52 0 011.85-3 10.74 10.74 0 012.61-2.07 11.27 11.27 0 011.54-.71C319.16 792.41 319.84 793.18 320.53 793.93zM324.76 798c-.45.27-.9.55-1.36.8a23.09 23.09 0 01-2.78 1.35 12.41 12.41 0 01-3.27.88 8.56 8.56 0 011.85-3 10.74 10.74 0 012.61-2.07c.16-.09.34-.17.51-.25C323.11 796.48 323.91 797.23 324.76 798z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a87c4",
    d: "M278.86,783.89c.78.12,1.57.23,2.36.33h0l3.63.45h.07c1.2.14,2.39.27,3.59.39l1.14.12h0c1.64.16,3.27.29,4.9.42l2.1.13.38,0,2,.1h0l2.16.06h0c.71,0,1.41,0,2.09,0h0a38.65,38.65,0,0,0,7.27-.6h0c-13.93-12.7-20.1-24.91-23.14-33.48-10.12-28.5-4.29-68.53-2.89-78.21,1.54-10.53,3.25-17.37-.34-25.57-4.68-10.71-14-14.45-31.4-22.92-15.85-7.7-30-14.59-40.47-22.78a19.92,19.92,0,0,1-6.16-23.83c2.47-5.38,7.39-9.8,16.72-10.49a96.28,96.28,0,0,0,44.88-15.63H188.24v0l0,0,0,.09,0,.08-.09.18,0,.06-.14.32-.05.11-.13.3-.06.15-.17.39,0,.11q-.12.27-.24.57l-.06.16c-.06.16-.13.32-.19.49l-.09.23-.21.55-.07.19c-.09.26-.19.53-.29.8l-.06.17-.24.69-.09.3c-.08.22-.15.44-.23.67l-.09.28-.3,1a1,1,0,0,0,0,.14l-.27.91-.09.35c-.07.26-.15.52-.22.79l-.09.35c-.1.38-.19.76-.29,1.16h0c-.1.39-.19.79-.28,1.19,0,.13,0,.26-.08.38-.06.3-.13.6-.19.91,0,.13-.05.27-.08.4-.07.37-.14.74-.2,1.11,0,.07,0,.14,0,.2-.07.44-.15.88-.21,1.33l-.06.39c-.05.33-.09.67-.14,1,0,.16,0,.31,0,.46q-.08.56-.12,1.11c0,.1,0,.21,0,.31,0,.48-.08,1-.11,1.43l0,.38-.06,1.1c0,.17,0,.33,0,.49,0,.37,0,.74,0,1.12,0,.13,0,.26,0,.4,0,.49,0,1,0,1.5,0,.11,0,.22,0,.33,0,.4,0,.81,0,1.21l0,.5.09,1.13c0,.15,0,.3,0,.45q.08.78.18,1.56l0,.23c.06.44.13.89.21,1.34l.09.5c.07.38.14.76.22,1.14,0,.16.07.32.11.49.11.52.23,1,.37,1.56a39,39,0,0,0,3.38,8.58c.26.49.54,1,.83,1.47.11.17.21.35.32.53.35.57.73,1.13,1.12,1.7l.3.42a40.12,40.12,0,0,0,2.65,3.32c.12.14.25.27.37.4.49.55,1,1.09,1.54,1.62a49.58,49.58,0,0,0,10.41,7.72c.59.34,1.2.67,1.82,1q5.61,2.93,10.8,5.51,3.47,1.72,6.74,3.32l3.22,1.56,6.16,2.94,5.76,2.71c11.1,5.21,19.71,9.18,25.37,12.69a36.54,36.54,0,0,1,3.69,2.55,18.8,18.8,0,0,1,1.82,1.64,7.34,7.34,0,0,1,2.24,4,16.11,16.11,0,0,1,.07,3.42c-.2,2.68-.86,5.77-1.59,9.7-.1.52-.19,1-.29,1.59s-.17,1-.25,1.44-.16,1-.25,1.52a129.26,129.26,0,0,0-1.4,25.15c0,.93.08,1.88.13,2.86.14,2.86.37,5.9.7,9.15.13,1.29.26,2.6.4,3.91l0,.36c.28,2.63.56,5.28.85,7.93l0,.33c.14,1.33.29,2.66.44,4,.19,1.66.37,3.32.56,5h0c.18,1.6.37,3.2.55,4.78l0,.25q.39,3.21.76,6.35c.13,1,.25,2,.37,3l0,.28c.11.93.23,1.86.34,2.77l0,.36q.36,2.89.71,5.65l0,.34c.24,1.88.48,3.71.7,5.47.94,7.29,1.77,13.5,2.37,17.88,0,.27.07.54.1.8s.07.51.11.76c.33,2.41.56,4.1.67,4.88C278.84,783.72,278.86,783.89,278.86,783.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M279.94,605.2c39.83,20.78,64.65,28.28,65.8,36.94s-6.35,20.21-2.88,54.84,9.23,75.61,9.23,75.61,30.59,4.62,35.21,0-1.15-62.59,4-114.7c0,0,9.81-25-3.17-40.57l-13.93-11.14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M423.43,805.48c-9.24-8.28-31.17-18.67-36.18-32.9-3.83,3.83-25.59,1.29-32.84.33h0s-3.52,11.21-3.71,19.29,0,10.39,0,10.39l13.47,1.73v-3.46s7.88.38,12.12,4.62,16.35,9.81,29.43,9.23S432.66,813.75,423.43,805.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc065",
    d: "M405.72,814.71c-13.09.58-25.21-5-29.44-9.23s-12.12-4.62-12.12-4.62v3.46l-13.47-1.73s-.19-2.31,0-10.39a67.15,67.15,0,0,1,1.92-12.67c.92-3.81,1.8-6.62,1.8-6.62,7.25,1,29,3.5,32.84-.33a26.29,26.29,0,0,0,4.52,7.74c.62.79,1.3,1.56,2,2.31s1.18,1.2,1.79,1.79c.79.76,1.59,1.51,2.44,2.25,8.53,7.42,19.54,13.55,25.43,18.81C432.65,813.75,418.8,814.13,405.72,814.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7c2f13",
    d: "M405.72 814.71c10.51-.46 21.5-.81 20.65-5.2-32.85 7.88-45.85-5-48.24-8.84s-8.19-4.24-8.19-4.24c-10.64-.11-16.33-3.5-19.14-6.09-.05.63-.09 1.26-.1 1.86-.19 8.08 0 10.39 0 10.39l13.47 1.73v-3.46s7.88.38 12.12 4.62S392.64 815.29 405.72 814.71zM393.76 782.63c-.63.42-1.29.82-1.94 1.19a18.32 18.32 0 01-2.78 1.34 11.69 11.69 0 01-3.27.88 8.71 8.71 0 011.85-2.95 10.94 10.94 0 012.61-2.06 10.18 10.18 0 011.54-.71C392.39 781.11 393.07 781.88 393.76 782.63zM398 786.67c-.45.27-.9.54-1.36.8a23.09 23.09 0 01-2.78 1.35 12.41 12.41 0 01-3.27.88 8.37 8.37 0 011.85-3 10.74 10.74 0 012.61-2.07 4.89 4.89 0 01.51-.26C396.34 785.18 397.14 785.93 398 786.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a87c4",
    d: "M279.94,605.2q5.61,2.92,10.8,5.51,3.47,1.72,6.74,3.31l3.22,1.57,6.16,2.93c2,.94,3.91,1.85,5.76,2.71,11.1,5.21,19.71,9.19,25.37,12.69a38.21,38.21,0,0,1,3.69,2.56,18.77,18.77,0,0,1,1.82,1.63,7.4,7.4,0,0,1,2.24,4,16.13,16.13,0,0,1,.07,3.42c-.2,2.68-.86,5.78-1.59,9.71-.1.52-.19,1-.29,1.59s-.17.95-.25,1.44-.16,1-.25,1.52A129.2,129.2,0,0,0,342,685c0,.94.08,1.89.13,2.87.14,2.86.37,5.9.7,9.15.13,1.29.26,2.6.4,3.91l0,.36c.28,2.63.56,5.28.85,7.93l0,.32c.14,1.33.29,2.67.44,4,.19,1.66.37,3.31.56,5v0c.18,1.6.37,3.2.55,4.78l0,.25q.39,3.21.76,6.35c.13,1,.25,2,.37,3l0,.29c.11.93.23,1.85.34,2.77l0,.36c.24,1.92.48,3.81.71,5.65l0,.34c.24,1.88.48,3.71.7,5.47.94,7.29,1.77,13.49,2.37,17.88,0,.27.07.54.11.8s.06.51.1.75c.33,2.42.56,4.11.67,4.89.05.33.07.5.07.5l2.36.33h0c1.22.17,2.43.32,3.63.46h.07c1.2.14,2.39.27,3.59.39l1.14.11h0c1.64.16,3.27.29,4.9.41l2.1.14.38,0c.66,0,1.33.07,2,.09h0l2.16.07h2.15a38.65,38.65,0,0,0,7.27-.6h0c-13.93-12.7-20.1-24.92-23.14-33.48-10.12-28.51-4.29-68.54-2.89-78.21,1.54-10.53,3.25-17.37-.34-25.57-2.93-6.7-7.66-10.67-15-14.77a100.16,100.16,0,0,0-30.2-10.74Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "310.67 785.64 306.22 781.6 306.47 781.35 310.67 785.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M298.33 772.92a80.66 80.66 0 01-6.64-9.73l1.27-.7a78.89 78.89 0 006.11 9.86zM286.61 752.51a86.18 86.18 0 01-3.34-11.34l2.29-.48a87.2 87.2 0 002.89 11.17zM281.27 729.53c-.48-3.91-.78-7.83-1-11.76l3-.1c.09 3.86.3 7.72.67 11.57z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "280.13 705.98 280.62 694.22 284.06 694.47 283.38 706.06 280.13 705.98"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M281.67 682.49c.51-3.88.94-7.78 1.52-11.65l3.74.57c-.64 3.83-1.11 7.67-1.67 11.51zM284.47 659.47a24.92 24.92 0 00-.43-5.41 22.83 22.83 0 00-1.65-5.12l3.58-1.61a27.73 27.73 0 011.89 6 29.1 29.1 0 01.48 6.22zM275.9 640.41a56.44 56.44 0 00-9.47-6.06l1.86-3.52a56.15 56.15 0 0110.17 6.55z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "256.03 629.16 245.51 624.02 247.22 620.55 257.73 625.63 256.03 629.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "235.04 618.73 224.73 613.03 226.55 609.89 236.78 615.37 235.04 618.73"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M214.77 606.6l-2.38-1.8a25.5 25.5 0 01-2.38-1.95 22.25 22.25 0 01-3.94-4.92l2.79-1.68a19.12 19.12 0 003.44 4.11 20.49 20.49 0 002.17 1.71l2.31 1.7zM203.07 585.87a20.18 20.18 0 014.4-11.59l2.12 1.69a17.41 17.41 0 00-3.53 10zM218 568a28.27 28.27 0 013-.52c1-.13 2-.17 3-.28l5.75-.56.3 1.94-5.86.78c-1 .14-1.93.21-2.85.35a25.12 25.12 0 00-2.74.57zM241.08 564.31a99.64 99.64 0 0011-3.66l.37.86a99.82 99.82 0 01-11 4.19zM262.69 555.76c1.76-.94 3.5-1.93 5.17-3-1.61 1.19-3.29 2.28-5 3.33z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Doctor/Head/Male"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.43 340.75s-10.66.53-11.26 12.76-9.78 8.8-9.78 8.8 6.15 9.36 18.46-.36 13.94-11 13.94-11 0-9.71-10.56-10.25M220.59 366.38s2.5 30.3 14.49 43.44.22-44.45.22-44.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M259.08,424.53c-.62-2.21,2-7.61,3.6-10.72-10.85,1.67-23.77-6-30.5-19.56a4.6,4.6,0,0,1-1.3.47s-1,28.21-7.16,28.56c-7.15,6.14-30.51,26.9-25.76,36.53,4,8.08,25.56,3.91,57.72-2.3a16.18,16.18,0,0,0,8.39-4c6.75-6.44,4.9-18,3.95-20.61C266.79,429.49,260,427.73,259.08,424.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M235.63,427.74c-4.26-9.24,4.69-11.19,4.69-11.19l-.06-.13c5.92,4,12.53,5.73,18.47,4.57.28-.05.55-.12.82-.19a47.94,47.94,0,0,1,3.13-7.06c-10.85,1.67-23.15-6.72-29.88-20.28a2,2,0,0,1-1.92,1.19s-.19,5.24-.91,11.24h0c-.94,7.92-2.78,17.18-6.26,17.38-9.7,8.23-33.09,29.16-28.4,38.45s36.81,6,60.36-4.22c3.59-1.56,6.52-3.09,8.65-4.27C249.62,454.85,239.46,436,235.63,427.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M245.89,341c-12.4,2.42-20,18.21-18.25,36.54h-.1c-3.39.66-5.39,5-4.46,9.77s4.42,8,7.8,7.37a2.78,2.78,0,0,0,2-1c6.89,13.87,19.53,22.11,30.53,20,13.66-2.66,18.49-19.51,14.47-40.14S259.54,338.37,245.89,341Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be3e5f",
    d: "M259.39,399.13a83,83,0,0,1,11.3,1.54s-.38-5.36-4.85-6S259.39,399.13,259.39,399.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M269,372.24c.44,2,.84,4,1.39,5.92a11.4,11.4,0,0,0,1.06,2.61c.19.33.53.8.81,1.22s.57.9.83,1.38a6.38,6.38,0,0,1,.93,3.44,3,3,0,0,1-.94,1.92,3.91,3.91,0,0,1-1.68.88,12.49,12.49,0,0,1-6.34-.45,24.09,24.09,0,0,0,5.84-1,2.92,2.92,0,0,0,.95-.64,1.12,1.12,0,0,0,.28-.81,5.49,5.49,0,0,0-.8-2.37c-.22-.42-.47-.83-.73-1.26s-.53-.8-.81-1.37a10.42,10.42,0,0,1-.92-3.18A19.31,19.31,0,0,1,269,372.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.85 369.55a45.19 45.19 0 006-.58 19 19 0 002.83-.73c.95-.29 1.83-.74 2.84-1.15a7 7 0 01-2.33 2.23 9.16 9.16 0 01-3.06 1.15 10.75 10.75 0 01-3.25.08A8.24 8.24 0 01250.85 369.55zM276 366.46c.16.48.32 1 .47 1.46l-.14 0a10.44 10.44 0 01-3.25.08 8.07 8.07 0 01-3.05-1A44.62 44.62 0 00276 366.46zM275.3 379.8a1.54 1.54 0 01-1.8-1.21l-.86-4.4a1.53 1.53 0 113-.58l.86 4.39A1.54 1.54 0 01275.3 379.8zM259.88 380.74a1.54 1.54 0 01-1.8-1.21l-.85-4.4a1.53 1.53 0 013-.58l.86 4.39A1.53 1.53 0 01259.88 380.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M227.42,381.78a13.74,13.74,0,0,0-.07,5,10.54,10.54,0,0,0,.75,2.24c.15.39.39.75.57,1.16s.45.79.64,1.27a6.74,6.74,0,0,1-1.35-.59,6.53,6.53,0,0,1-1.15-.95,5.62,5.62,0,0,1-1.19-5.8A4.75,4.75,0,0,1,227.42,381.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.54,377.51s5.86,20.61,10.69,27.45c4.45,6.32,12.8,12.57,25.79,11.21a12.88,12.88,0,0,0,6.74-2.74c3.8-3.07,9.25-9.53,8.21-20.94,0,0-3.32-3.74-12.23-3.55s-11.18,2.47-12.71,4.21-8.33,10.05-11.75,7.45-11.61-19.39-7.74-28.43,8.33-5.31,3.6-15.6c0,0,6.77-2.48,18.6.11a10.32,10.32,0,0,0,7.2-.93c1.77-1,3.37-2.43,3.22-4.45a65,65,0,0,1,8,12.77s5.72-8.71-2.28-15.94c-6.8-6.14-8.94-9.82-11.21-10.68-4.52-1.71-6.41,1-10.87,1.78s-5.29-2.05-10.48.71-7.39,6.92-9.15,10.88c0,0-5.09-.7-9.74,8.43C219.42,363.3,218.7,383.93,227.54,377.51ZM258,393.34c1.22-1.16,4.71-3.06,9.79-2.16,4.85.85,5.5,4,6.25,6.39a8,8,0,0,1,.34,3.57c-.33,2.4-1.56,3.28-3.7,3.51-2.63.29-3.21-3.56-5.11-3.36s-1.62,3.47-6.3,3.67S254.85,396.35,258,393.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Doctor/Torso"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M366.16,536.6l10.32.41s2.25-1.78,5.29-4.1c5.76-4.4,14.38-10.72,16.15-10.61,2.71.16,7.42,2.13-4.3,11.15l.09.08c.39.3,2.2,1.49,6.83,1.77,5.33.33,23.28,1.55,26.2,2.64,1.58.6,5.13,5.36-21.48,4.42a1.43,1.43,0,0,0-1.51,1.6c.09.5.45.93,1.41,1,2.41.15,23.22.5,22.86,4.26-.26,2.73-5.71,2.06-23.95,1.26,0,0-2.9.74-.59,2.23.8.52,21.42,2.44,22.43,4.08s3.66,4.31-27.27.92c0,0-.55.31,2.15,1.89,2.86,1.67,11.32,3.91,13.48,7.06s-4.12.66-20-4.68L372,559.14c-14.73,2.08-69.85,6.78-83.54-7.44-12.83-13.32-19.73-61-19.73-61l31.37-1.06,13.14,35.55a6.92,6.92,0,0,0,5.48,4.44l49.33,7.12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M280.58,490.35,291.76,492s-2.92,38.3,7.4,46,24.72,14.64,86.4,14.88c19.94.07,32.62,2,40.67,4.47.83,1.54.07,3.43-27.59.4,0,0-.55.31,2.15,1.89,2.86,1.67,11.32,3.91,13.48,7.06s-4.12.66-20-4.68L372,559.14c-14.73,2.08-69.85,6.78-83.54-7.44-12.83-13.32-19.73-61-19.73-61Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2f170b",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M393.94,533.51s-4.32,16.18-19.09,11.71"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5061",
    d: "M107.11,642.26h86.22a7.33,7.33,0,0,1,7.33,7.33V696.1a0,0,0,0,1,0,0H99.77a0,0,0,0,1,0,0V649.59A7.33,7.33,0,0,1,107.11,642.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fc7e85",
    points: "99.78 696.1 99.78 685.48 110.74 696.1 99.78 696.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fc7e85",
    points: "200.65 696.1 200.65 685.48 189.68 696.1 200.65 696.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc7e85",
    d: "M99.77,649.59v2.67H200.65v-2.67a7.33,7.33,0,0,0-7.33-7.33H107.11A7.34,7.34,0,0,0,99.77,649.59Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 366.71,
    x2: 366.71,
    y1: 536.6,
    y2: 558.78,
    fill: "none",
    stroke: "#2f170b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M303.84,486.76l-10.3-32.34a39.07,39.07,0,0,0-13-19,27.78,27.78,0,0,0-5.07-3.22,1,1,0,0,0-1.43.94L276,492h24A4,4,0,0,0,303.84,486.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a87c4",
    d: "M274.48,445.63,276,492h15.78c.36-11.25-.48-23.69-7.05-37.51-4.48-9.42-7.07-9.89-8.16-9.84A3.29,3.29,0,0,0,274.48,445.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M130,626.3a23.8,23.8,0,0,0,.73-5.51c.23-15.56,1.71-74.95,10.68-102,2.85-8.63,29.06-52.54,29.06-52.54l37.44,7.92L175,529a27.41,27.41,0,0,0-3.19,7.83l-20.11,85.64a8.09,8.09,0,0,0,1.49,6.82c4.23,5.43,12.61,16.46,12.47,18.49-.18,2.71-2.18,7.41-11.13-4.37,0,0-1.53,1.58-1.89,6.91s-1.12,25.84-2.81,26.18-5.49,5.23-4.22-22.65c0,0-2.48-1.38-2.64,1s-1.54,25.29-4.4,22.83-2-5.73-1.12-24c0,0-1.87-1.48-2.23-.6s-2.41,22.52-4.22,22.4-4.32,3.64-.75-27.27c0,0-1-.52-2.13,2.58s-5.5,16.72-6.92,13-.63-4.12,4.81-19.93L130,626.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M207.93,474.16l-8.83-1.87c-6.6,8.37-14.8,14.46-25.49,30.1-8.32,12.18-13.71,24.59-16.1,29.83-6.56,14.36-5.23,21.69-9.6,57.12-2.63,21.28-3.94,31.91-5.32,37.48,0,0-9.89,39.85-5.06,49.72a2.78,2.78,0,0,0,1,1.12c2.86,2.46,4.23-20.42,4.4-22.83s2.64-1,2.64-1c-1.27,27.88,2.54,23,4.22,22.65s2.45-20.76,2.81-26.14h0v0c.36-5.33,1.89-6.91,1.89-6.91,8.95,11.78,10.95,7.08,11.13,4.37.14-2-8.24-13.06-12.47-18.49a8.09,8.09,0,0,1-1.49-6.82l20.11-85.64A27.41,27.41,0,0,1,175,529Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M274.35,560.13h-77.5a8.44,8.44,0,0,1-8.34-9.7L206.8,429.72l16.68-6.32c6.73,14.27,29.63,17.07,36.24,2.75L274,431.59a10.87,10.87,0,0,1,8.3,11.15l-.15,4.5Q280.4,501.63,278.62,556C278.61,556.3,278.53,557.76,274.35,560.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25beef",
    d: "M156.21,490.17a4,4,0,0,1-1-5.67l28.2-39.16s10-12.88,23.34-15.62l7.62,39.74-26.95,41a1.35,1.35,0,0,1-1.9.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a87c4",
    d: "M187.47,510.42l26.77-40.68-.06-.39a4.34,4.34,0,0,0-6.9-2.8c-5.1,3.88-11.63,10.58-17.61,16.71-6.25,6.4-12.94,13.27-16.06,19.13l12,8.39A1.35,1.35,0,0,0,187.47,510.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a87c4",
    d: "M278.62,556c-5.88-2.07-21.16-2.15-44.31-9.44-21.73-6.85-26.11-12.4-28.08-16.38-4.65-9.36-1.61-21.22-.36-26.1,2.24-8.76,2.88-12.11,7.38-23.22,1.51-3.73,2-12.76,0-13.5-2.33-.86-8.92,9.2-15.66,23.16l-9.08,59.91a8.44,8.44,0,0,0,8.34,9.7h77.5a4.27,4.27,0,0,0,4.27-4.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fc7e85",
    d: "M167.22,642.26H155.16a7.85,7.85,0,0,0-.81,3.78c0,2.43,3.24,4.86,3.24,4.86s6.57,1.26,8.1.54S167.22,642.26,167.22,642.26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 23.8,
    height: 9.08,
    x: 214.24,
    y: 457.51,
    fill: "#e3eaf3",
    rx: 2,
    transform: "rotate(-180 226.145 462.05)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Patient/Bottom/Side"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M558.75,599.81c0,14.15,6.54,27,11.3,31.35,3.37,3.1,4.13,8.16,4.28,10.85a23.19,23.19,0,0,0,.91,5.42c1.35,4.38,4.38,11.14,10.3,10.75,4.35-.29,6.56-2,10.62-3.18s10.35-5.09,10.35-5.09c-1.37-7.77-6.16-27.41-2.2-31.72-3-.91-5.08-2.85-7.81-4.88-.88-.64-1.74-1.34-2.59-2-.68-.61-1.35-1.22-2-1.85-.84-.82-1.69-1.65-2.53-2.53-8.4-8.87-15.51-20.48-21.45-26.59C558.56,570.69,558.78,585.66,558.75,599.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc065",
    d: "M892.4,561.23s-139.21,7.39-151.33,8.92S602.93,617.7,602.93,617.7s-4.42,20,3,32.58c0,0,102.7-18.4,126.82-24.07l43.86-9.36S877,643.27,895.62,638a89.33,89.33,0,0,0,25.28-11.64S886,582.1,892.4,561.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa39",
    d: "M895.62,638a89.33,89.33,0,0,0,25.28-11.64S886,582.1,892.4,561.23l-4.87.26a46.73,46.73,0,0,1-7.16,21.1c-11.63,18.27-32.22,24.34-37.08,25.63-25,6.62-36.62-6.62-66.59-8a104.67,104.67,0,0,0-14.83.69,254.28,254.28,0,0,0-63.65,13.37c-18.69,6.2-48,19.16-96.6,17.52.07,6,1,13,4.27,18.48,0,0,102.7-18.4,126.82-24.07l39.77-2.41S877,643.27,895.62,638Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M601.9,637s78.24-17,113.24-25.53a178.89,178.89,0,0,1,25.09-4.26l5-.49a180.07,180.07,0,0,1,41.18.74c31.44,4.2,90.16,11.19,103.53,6.9,10.8-3.47,11.25-4.11,17-8.23"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Patient/Head/Male/Side"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M977.52,413.44a37.36,37.36,0,0,0-3.72,4.63c-6.56,9.55-6.49,12-16.73,14.89,0,0-8.46,3.84-.8,8.43,0,0,0,1.32-2,4.48-1.93,3-14.86,15.42,9.05,24.58a3,3,0,0,1,1.25,4.68l-21.21,21.94,27,17.11,29.07-46.84s-6.32-5.78-7.24-6.38c0,0,14.58-6.39,8.39-12.08s-11.33-.07-11.33-.07l-2.46-2,12.55-19.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M999.41,469l-6.12,8s-1.62-9.27-2.74-13.26a2.3,2.3,0,0,1,1.18-2.67c4.24-2.15,13.79-7.72,8.9-12.21s-10.75.5-13.11,2.87a1.69,1.69,0,0,1-2.27.14h0a1.71,1.71,0,0,1-.36-2.26l7.4-11.28a13.13,13.13,0,0,0-4.07-18.18l-7.34-4.62a4.53,4.53,0,0,0-6,1.11h0c1.12-5.5,6.44-7.83,8.26-8.59,11.45-4.81,23.24,3.07,25.8,4.78,7,4.72,15.26,14,13.23,20.14-.5,1.53-1.88,5.49-1.88,5.49s3.4,3.67,3.65,6.46c.45,5.17-6.92,11.13-16.08,18.48C1003.48,466.87,1001,468.35,999.41,469Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M982,431a11.37,11.37,0,0,1-3.3-1.66,15.55,15.55,0,0,1-2.75-2.44,14.43,14.43,0,0,1-2.11-3,9.91,9.91,0,0,1-1.1-3.56c.89.91,1.61,1.81,2.4,2.67l2.3,2.59C979,427.32,980.53,429,982,431Z"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 974.28,
    x2: 970.58,
    y1: 430.22,
    y2: 435.93,
    fill: "none",
    stroke: "#000001",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#be3e5f",
    d: "M958.28,451.74c-.33-1.74-3-6.35-3.83-6.16l-.18.29a51.17,51.17,0,0,0-3.54,5.13C952.89,453.21,958.29,451.79,958.28,451.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d18165",
    d: "M994.17 449.8a4.84 4.84 0 014 .48 2.41 2.41 0 011 2.08 4.07 4.07 0 01-.9 2 9.4 9.4 0 01-3.2 2.56 7 7 0 01-1.94.68 2.77 2.77 0 01-2-.25 2.86 2.86 0 001.87-.23 8.37 8.37 0 001.68-.87 11.16 11.16 0 002.79-2.5 3.2 3.2 0 00.76-1.5 1.67 1.67 0 00-.53-1.4A5.75 5.75 0 00994.17 449.8zM949.67 499.49c4.73 2 23.93-12.31 29.93-18.55s3.28-8.7 3.28-8.7c-5.8 1.82-18.75-1.32-18.75-1.32h0a3 3 0 01.45 4.2l-19 19.26C946.52 496.64 947.84 498.71 949.67 499.49z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Patient/Torso/Side"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc065",
    d: "M884.86,538.39c21.13-31.66,31.11-40.14,46.9-48.7A87.46,87.46,0,0,1,959,480.52c-3.62,4.9-6.13,6.85-7,8.92-1.36,3.1,11.37,2.85,32.73,2.44a17.46,17.46,0,0,0-1.55,5.08,15.12,15.12,0,0,0,.69,5.76,34.26,34.26,0,0,1-.72,22.2,151.5,151.5,0,0,1-6.58,14.93,231.51,231.51,0,0,1-22.19,34.45c-8,10.11-14,15.75-20.75,28.62-3.85,7.37-3.75,9.1-5.83,10.68-6.45,4.87-23.51.49-69.06-37.63a4.22,4.22,0,0,1,.68-6.94C869.38,561.45,877.91,548.82,884.86,538.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa39",
    d: "M886.78,598.55l21.87,14.8a77.09,77.09,0,0,0,12.64,6.08c6.82-5.84,29.06-33.11,30.14-35.31l22.63-46.58a23.4,23.4,0,0,0,1.84-17c-2.27-8.16-8.21-17.7-23.69-15.74l-6.53,2A37.29,37.29,0,0,0,924,524.69l-19.92,34.86c-1.82,2.66-4,2.39-3.3,5.54a5,5,0,0,1,.08,2.65,103,103,0,0,1-18.54,27.4C883.85,596.33,885.34,597.46,886.78,598.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ea9d7d",
    d: "M828.12,659.93a24.36,24.36,0,0,1,4.51-3.25c13.61-7.55,65.25-36.92,84.87-57.6,6.25-6.6,32.57-50.44,32.57-50.44L925.4,519.38l-32.7,55a27.67,27.67,0,0,1-5.4,6.51l-66,58.18a8.08,8.08,0,0,1-6.71,1.91c-6.78-1.16-20.46-3.33-22.18-2.26-2.31,1.44-5.51,5.43,9.11,7.75,0,0-.67,2.09-5.2,4.93s-22.25,13.2-21.75,14.84-2,7.31,22-7c0,0,2.38,1.53.33,2.81s-21.56,13.31-18,14.67,6-.91,21.65-10.34c0,0,2.19.95,1.58,1.68s-18.7,12.77-17.74,14.3-1.17,5.53,24.38-12.22c0,0,.94.65-1.26,3.1s-12.13,12.75-8.18,12.23,3.93-1.39,15.29-13.65l13.57-11.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc065",
    d: "M935.59,575.42a4.27,4.27,0,0,0,5.75-1.93l22.32-45.7a.67.67,0,0,0,.07-.14c5.52-12.9-6.7-26.34-20.1-22.16L939,506.93a34,34,0,0,0-19.74,16.24l-18,33.3a1.41,1.41,0,0,0,.61,1.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffaa39",
    d: "M963.86,527.71l.73-1.56.36-.8.23-.84c.15-.57.33-1.13.45-1.71s.13-1.17.19-1.77a8.82,8.82,0,0,0,0-1.78,9.71,9.71,0,0,0-.19-1.79l-.37-1.78c-.17-.58-.41-1.14-.61-1.71a17.51,17.51,0,0,0-10.35-9.89,16.41,16.41,0,0,0-7.35-.81l-.93.1a7.26,7.26,0,0,0-.9.2l-1.79.45c-1.1.35-2.15.73-3.23,1.09s-2.17.73-3.27,1.17a29,29,0,0,0-3.19,1.51,32.2,32.2,0,0,0-5.73,4,43.41,43.41,0,0,0-8.76,10.6c-2.27,4-4.84,7.69-7.17,11.59s-4.38,7.92-6.4,12c-1,2-2,4.07-2.91,6.14-.48,1-.93,2.08-1.38,3.12L901,556a2.22,2.22,0,0,0-.26,1,1.67,1.67,0,0,0,1.06,1.57l.14-.27a1.18,1.18,0,0,1-.5-1.23,7.37,7.37,0,0,1,.81-1.32c.63-1,1.26-1.89,1.86-2.86,1.23-1.91,2.4-3.85,3.56-5.8,2.3-3.9,4.54-7.84,6.55-11.9s3.71-8.31,5.81-12.3a27.65,27.65,0,0,1,8.92-9.78,35.72,35.72,0,0,1,5.79-3.15c1-.43,2-.83,3-1.18l1.56-.49,1.63-.46,3.26-.92,1.52-.32a6.63,6.63,0,0,1,.75-.15l.77,0a14.82,14.82,0,0,1,6,.72,16.18,16.18,0,0,1,9.23,7.85,15.74,15.74,0,0,1,1.78,6.08,18.4,18.4,0,0,1-.7,6.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Seater 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#396e8e",
    d: "M916.72 638.48l7.92 2.35a19.55 19.55 0 0020.72-6.38c20.51-25.1 72.8-91.35 87-131.08a23.13 23.13 0 00-2-20.3 13.74 13.74 0 00-5.29-5.11zM1033 406.74s12.27 2.59 12.27 10.61c0 6.29-7.13 31.74-10.19 42.36a7.63 7.63 0 01-7 5.51 12.81 12.81 0 01-5.75-.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54a4cc",
    d: "M653.12,702.85l71.93-30.71,148.57,62-88.46,14.44a139.48,139.48,0,0,0-88.48,53.15h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396e8e",
    d: "M513.68 801.69s26.87-95.32 130-109.19c0 0 53.15 52 53 109.19zM705.21 632.37S707.52 784 873.62 764.1h0a38.71 38.71 0 0038.71-38.71V654.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#396e8e",
    d: "M519.3,698.7s-.58,9.25,9.82,10.4,180.49-38.33,180.49-38.33l11.72,22.73L736,662.31l-30.74-29.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54a4cc",
    d: "M519.3,684.26l182-75.63a52.8,52.8,0,0,1,18.84-.52l162,24.72A45,45,0,0,1,912.21,651c3.92,5.55,6.18,11.56,3,16.33-8.08,12.13-210-35-210-35L519.3,698.7S511.21,692.35,519.3,684.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3eaf3",
    d: "M873.56,678.25l-1.23-8.94c-.94-5.51-2.2-11-3.28-16.44-.61-2.71-1.47-5.43-2.2-8.12s-1.43-5.38-2.35-8l-2.88-7.92c-.5-1.3-.91-2.62-1.48-3.91L858.38,621a105.46,105.46,0,0,0-17.8-28.23c-1.81-2.1-3.92-4-5.84-5.9l-3.19-2.63a29,29,0,0,0-3.29-2.46,43.69,43.69,0,0,0-14.5-7,41.8,41.8,0,0,1,11.9,9.92,27.63,27.63,0,0,1,2.42,3l2.26,3.06c1.29,2.22,2.72,4.28,3.85,6.55a93.57,93.57,0,0,1,9.28,28.46l.68,3.65c.21,1.23.28,2.5.43,3.74l.76,7.44c.21,2.47.17,5,.27,7.51s.19,5,.12,7.47c-.27,5.06-.36,10-.76,15l-.91,8.31a16.41,16.41,0,1,0,29.5-.67Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 858.97,
    cy: 685.73,
    r: 8.89,
    fill: "#396e8e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54a4cc",
    d: "M916.72 638.48l-3.93-1.87a15 15 0 01-7.4-19.26c12.08-29.23 45-99.79 96.21-141.34a23.79 23.79 0 0116.56-5.58c5.06.36 9.28 2.63 6 10.29C1017.47 496 916.72 638.48 916.72 638.48zM1022.39 463.6l12.34-66.51s-3.28-4.31-9.43 3.46c-6.51 8.24-14.74 20.75-17.21 27.52C1005.17 436.07 992.27 464.9 1022.39 463.6zM1048.64 439.1a14.87 14.87 0 00-6.24-6.44c-.59 2.42-1.23 4.94-1.89 7.48a7.62 7.62 0 011.68 2.22c2.13 4.21 3.14 14.9-12.29 40.09.15.21.3.4.44.62a21.4 21.4 0 013 7.45C1048.68 466.69 1053.84 449.38 1048.64 439.1zM927.63 641.46c-1.17 18.79-9.58 29.36-15.3 34.45v14.43l.09.18c1.1-.55 26.44-13.68 27.35-51.44A19.53 19.53 0 01927.63 641.46zM514 802H913.1a13.49 13.49 0 0113.48 13.48h0v10.6H500.49v-10.6A13.49 13.49 0 01514 802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e3eaf3",
    d: "M865.19,796H901.3a2.41,2.41,0,0,1,2.41,2.41h0V802H862.78v-3.61a2.41,2.41,0,0,1,2.41-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#54a4cc",
    d: "M881.63 785.66h3.23a10.3 10.3 0 0110.3 10.3H871.33a10.3 10.3 0 0110.3-10.3zM860.34 604.16a9.6 9.6 0 01-7.88-4.08c-13.17-18.69-70.93-19.51-104.26-15.63A9.63 9.63 0 01746 565.32C756 564.17 844.22 555 868.2 589a9.63 9.63 0 01-7.86 15.18z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDentistClinic);
export default __webpack_public_path__ + "static/media/dentist-clinic.01c6ec70e68913d3f1b4bff79efe80be.svg";
export { ForwardRef as ReactComponent };